// The public landing page is deliberately off the shared useColorTheme() palette: KAN-6 gives
// only that screen a black-and-yellow scheme while every other screen keeps the purple default.
import type { ColorTheme } from '../contexts/ColorThemeContext';

export interface LandingTheme extends ColorTheme {
  /** Page wrapper background. */
  pageBg: string;
  /** Default section background. */
  sectionBg: string;
  /** Alternating section background, for bands next to `sectionBg`. */
  sectionBgAlt: string;
  /** Card surface sitting on top of a section. */
  cardBg: string;
  /** Card border at rest. */
  cardBorder: string;
  /** Card border on hover. */
  cardBorderHover: string;
  /** Heading text on a dark surface. */
  heading: string;
  /** Body copy on a dark surface. */
  body: string;
  /** Small print on a dark surface. */
  bodyMuted: string;
  /** Text and icons that sit on a yellow surface. */
  onAccent: string;
}

// Every value is a whole literal Tailwind class so the JIT keeps it in the production CSS.
export const landingTheme: LandingTheme = {
  name: 'landing-noir',
  primary: 'from-yellow-400 to-amber-300',
  secondary: 'text-yellow-400',
  accent: 'bg-yellow-400 hover:bg-yellow-300',
  pageBg: 'bg-black',
  sectionBg: 'bg-neutral-950',
  sectionBgAlt: 'bg-neutral-900',
  cardBg: 'bg-neutral-900',
  cardBorder: 'border-neutral-800',
  cardBorderHover: 'hover:border-yellow-400/60',
  heading: 'text-white',
  body: 'text-neutral-300',
  bodyMuted: 'text-neutral-400',
  onAccent: 'text-neutral-950',
};
